import { render, staticRenderFns } from "./CommentActions.vue?vue&type=template&id=97a7f772&scoped=true&"
import script from "./CommentActions.vue?vue&type=script&lang=js&"
export * from "./CommentActions.vue?vue&type=script&lang=js&"
import style0 from "./CommentActions.vue?vue&type=style&index=0&id=97a7f772&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a7f772",
  null
  
)

export default component.exports